module.exports =  {
  TRANSCRIPT_TITLE: 'Transcript',
  CODED_BY_ME_TITLE: 'Transcript | Coded by Me',
  DEMOGRAPHICS_TITLE: 'Participant Information',
  COMPARISON_TITLE: 'Coding Comparison',
}
